module.exports = __webpack_public_path__ + "static/media/vw-amarok.cf736802.webp";